import React, { useState, useRef } from 'react';
import { TimerIcon } from '@common_components/icons/timer.icon';
import { PauseIcon, PlayIcon, StopIcon, Button } from '@umanforge/common';
import { useTranslation } from 'react-i18next';

interface TimerButtonProps {
  className?: string;
}

const TimerButton: React.FC<TimerButtonProps> = ( { className } ) => {

  const formatTime = ( time: number | null ) => {
    if ( time === null ) {return '00 : 00s';}
    const minutes = Math.floor( time / 60 );
    const seconds = time % 60;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${formattedMinutes} : ${formattedSeconds}s`;
  };

  const { t } = useTranslation();

  const [ time, setTime ] = useState<number | null>( null );
  const [ isRunning, setIsRunning ] = useState( false );
  const [ isChronoVisible, setIsChronoVisible ] = useState( false );
  const timerRef = useRef<NodeJS.Timeout | null>( null );

  const handleStart = () => {
    setIsChronoVisible( true );
    if ( !isRunning ) {
      setIsRunning( true );
      timerRef.current = setInterval( () => {
        setTime( prevTime => {return ( prevTime !== null ? prevTime + 1 : 1 );} );
      }, 1000 );
    }
  };

  const handlePause = () => {
    if ( isRunning && timerRef.current ) {
      clearInterval( timerRef.current );
      setIsRunning( false );
    }
  };

  const handleStop = () => {
    if ( timerRef.current ) {
      clearInterval( timerRef.current );
    }
    setIsRunning( false );
    setTime( null );
    setIsChronoVisible( false );
  };

  return (
    <div className={`${className} flex-center`}>
      <div className={`${isChronoVisible ? 'hidden' : 'block'}`}>
        <div id='event_manager_stopwatch_icon'>
          <Button
            onClick={() => {handleStart();}}
            className="py-2 trans-fast hover:shadow-md hover:text-orange-600 px-2 flex rounded-md hover:bg-orange-100"
            tooltip={ t( 'translation:stopwatch' ) }
            icon={<TimerIcon size={5}/>}
          />
        </div>
      </div>

      <div className={`${isChronoVisible ? 'flex' : 'hidden'} appear-jump font-title py-1 px-2 gap-x-2  bg-orange-200 text-orange-600 rounded-xl shadow-inner drop-shadow items-center`}>
        <p className="text-lg flex-center mx-2">
          {formatTime( time )}
        </p>
        <div className="flex items-center space-x-1 h-full">
          {!isRunning && (
            <Button
              onClick={handleStart}
              className="hover:bg-orange-100 trans-fast p-1 rounded-xl"
              icon={<PlayIcon className='h-7 w-7'/>}
            />
          )}
          {isRunning && (
            <Button
              onClick={handlePause}
              className="hover:bg-orange-100 trans-fast p-1 rounded-xl"
              icon={<PauseIcon className='h-7 w-7'/>}
            />
          )}
          <Button
            onClick={handleStop}
            className="hover:bg-orange-100 trans-fast p-1 rounded-xl"
            icon={<StopIcon className='h-7 w-7'/>}
          />
        </div>
      </div>
    </div>
  );
};

export default TimerButton;
